import { render, staticRenderFns } from "./order.pug?vue&type=template&id=f794832e&lang=pug&"
import script from "./order.ts?vue&type=script&lang=ts&"
export * from "./order.ts?vue&type=script&lang=ts&"
import style0 from "./order.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports